/**
 * APLPHANUMERIC + SPACES VALIDATOR
 *
 * @param value
 * @returns {boolean}
 */
export default value => {
    if (! /^[a-zA-Z0-9\s]+$/.test(value)) {
        return false;
    }

    return true;
};